import STORE_CONST from '../consts'
import clusterApi from '../../api/cluster'

const state = {
	cluster: {
		newAgentVersion: '',
		list: [],
		detail: {
			info: {},
			settings: {
				logFilters: [],
				shares: [],
				cloudName: '',
				accessKeyId: '',
				accessKeySecret: '',
				region: {
					id: '',
					name: '',
				},
			},
		},
		// 新增：存储集群配置轮询实例
		configPollingInstance: null,
	},
}

const mutations = {
	// cluster list
	[STORE_CONST.CLUSTER.GET](state, list) {
		state.cluster.list = list
	},
	// cluster detail
	[STORE_CONST.CLUSTER.GET_DETAIL](state, detail) {
		state.cluster.detail.info = detail
	},
	// update cluster detail resource list
	[STORE_CONST.CLUSTER.UPDATE_DETAIL](state, info) {
		state.cluster.detail.info = Object.assign({}, state.cluster.detail.info, info)
	},
	// sharing cluster list
	[STORE_CONST.CLUSTER.GET_SHARING](state, list) {
		state.cluster.detail.settings.shares = list
	},
	// 最新agent版本
	[STORE_CONST.CLUSTER.AGENT_VERSION](state, version) {
		state.cluster.newAgentVersion = version
	},
	// 新增：设置轮询实例
	[STORE_CONST.CLUSTER.SET_CONFIG_POLLING_INSTANCE](state, instance) {
		state.configPollingInstance = instance
	},
	// 新增：清空轮询实例
	[STORE_CONST.CLUSTER.CLEAR_CONFIG_POLLING_INSTANCE](state) {
		state.configPollingInstance = null
	},
}

const actions = {
	// 获取集群列表
	[STORE_CONST.CLUSTER.GET]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.getClusterList(params).then(
				(res) => {
					commit(STORE_CONST.CLUSTER.GET, res.data.objects)
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取集群列表V1
	[STORE_CONST.CLUSTER.GET_CLUSTER]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.getClusterListV1(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 添加集群
	[STORE_CONST.CLUSTER.ADD]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.addCluster(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},
	// 删除集群
	[STORE_CONST.CLUSTER.DELETE]({ commit }, id) {
		return new Promise((resolve, reject) => {
			clusterApi.deleteCluster(id).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// change cluster
	[STORE_CONST.CLUSTER.CHANGE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.changeCluster(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取一集群详情
	[STORE_CONST.CLUSTER.GET_DETAIL]({ commit }, id) {
		return new Promise((resolve, reject) => {
			clusterApi.getClusterDetail(id).then(
				(res) => {
					commit(STORE_CONST.CLUSTER.GET_DETAIL, res.data)
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// get cluster detail instances and databases list
	[STORE_CONST.CLUSTER.DETAIL_LIST]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.getInstancesList(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取某个集群下面的工作组资源（工作组添加资源筛选）
	[STORE_CONST.CLUSTER.GET_CLUSTER_RESOURCE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.getClusterResourceList(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// delete clustrer detail instances and databases resource
	[STORE_CONST.CLUSTER.DELETE_RESOURCE]({ commit }, ids) {
		return new Promise((resolve, reject) => {
			clusterApi.delDetailResource(ids).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 批量删除资源
	[STORE_CONST.CLUSTER.BATCH_DELETE_RESOURCE]({ commit }, ids) {
		return new Promise((resolve, reject) => {
			clusterApi.batchDeleteResource(ids).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 集群详情中主机和数据库的添加
	[STORE_CONST.CLUSTER.ADD_RESOURCE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.addClusterResource(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},
	// check update version
	[STORE_CONST.CLUSTER.CHECK_AGENT]({ commit }) {
		return new Promise((resolve, reject) => {
			clusterApi.updateAgent().then(
				(res) => {
					commit(STORE_CONST.CLUSTER.AGENT_VERSION, res.data.version)
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// get sharing cluster list
	[STORE_CONST.CLUSTER.GET_SHARING]({ commit }, id) {
		return new Promise((resolve, reject) => {
			clusterApi.getSharing(id).then(
				(res) => {
					commit(STORE_CONST.CLUSTER.GET_SHARING, res.data.networks)
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 添加分享集群
	[STORE_CONST.CLUSTER.ADD_SHARING]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.addSharing(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 取消分享集群
	[STORE_CONST.CLUSTER.CANCEL_SHARE]({ commit }, id) {
		return new Promise((resolve, reject) => {
			clusterApi.cancelShareCluster(id).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 添加日志过滤
	[STORE_CONST.CLUSTER.ADD_LOG_FILTER]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.addLogFilter(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 删除某一过滤日志
	[STORE_CONST.CLUSTER.DEL_LOG_FILTER]({ commit }, id) {
		return new Promise((resolve, reject) => {
			clusterApi.delLogFilter(id).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 批量删除过滤日志
	[STORE_CONST.CLUSTER.DEL_BARCH_LOG_FILTER]({ commit }, ids) {
		return new Promise((resolve, reject) => {
			clusterApi.batchDelLogFilter(ids).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取数据库拦截指令列表
	[STORE_CONST.CLUSTER.GET_INTERCEPTS_COMMADN]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.getInterceptsCommand(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取一资源详情
	[STORE_CONST.CLUSTER.GET_RESOURCE_DETAIL]({ commit }, id) {
		return new Promise((resolve, reject) => {
			clusterApi.getDetailResource(id).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 修改一资源的详情
	[STORE_CONST.CLUSTER.PATCH_RESOURCE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.patchDetailResource(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取安全模式审核人列表
	[STORE_CONST.CLUSTER.GET_SAFE_APPROVER]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.getSafeApprover(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},
	// 添加拦截指令
	[STORE_CONST.CLUSTER.ADD_INTERCEPT]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.addIntercept(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 删除拦截指令
	[STORE_CONST.CLUSTER.DEL_INTERCEPT]({ commit }, ids) {
		return new Promise((resolve, reject) => {
			clusterApi.deleteIntercept(ids).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 删除拦截指令
	[STORE_CONST.CLUSTER.DEL_ALARM_INTERCEPT]({ commit }, ids) {
		return new Promise((resolve, reject) => {
			clusterApi.deleteAlarmIntercept(ids).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 扫描导入开始
	[STORE_CONST.CLUSTER.SCAN_SATRT]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.scanImportStart(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 扫描导入轮询
	[STORE_CONST.CLUSTER.SCAN_QUERY]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.scanImportQuery(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 新版扫描导入轮询
	[STORE_CONST.CLUSTER.SCAN_NEW_QUERY]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.getNewAgentQuery(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 批量导入资源
	[STORE_CONST.CLUSTER.POST_BATCH_RESOURCE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.postBatchResource(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},
	// 云账号导入主机
	[STORE_CONST.CLUSTER.CLOUD_IMPORT_ECS]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.cloudImportECS(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},
	// 云账号导入数据库
	[STORE_CONST.CLUSTER.CLOUD_IMPORT_RDS]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.cloudImportRDS(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},
	// 测试连通性
	[STORE_CONST.CLUSTER.TEST_CONNECTION]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.testConnection(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 轮询测试连通性
	[STORE_CONST.CLUSTER.QUERY_TEST]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.queryTestConnection(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 测试key的可用性
	[STORE_CONST.CLUSTER.TEST_KEY_AVALIABLE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.testKeyAvaliable(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 测试key可用性轮询
	[STORE_CONST.CLUSTER.QUERY_KEY_AVALIABLE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.queryTestAvaliable(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// xlsx批量导入资源
	[STORE_CONST.CLUSTER.XLSX_BATCH_IMPORT]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.xlsxBatchImport(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},
	// 获取集群中全部资源连接次数统计
	[STORE_CONST.CLUSTER.GET_CLUSTER_RESOURCE_STATISTIC]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.getClusterResourceStatistic(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取集群中network连接次数统计
	[STORE_CONST.CLUSTER.GET_CLUSTER_STATISTIC]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.getClusterStatistic(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取资源组统计
	[STORE_CONST.CLUSTER.GET_RESOURCE_STATISTIC]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.getResourceStatistic(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 上传sshkey
	[STORE_CONST.CLUSTER.UOLOAD_SSHKEY]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.uploadSshkey(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 轮询上传sshkey
	[STORE_CONST.CLUSTER.QUERY_SSHKEY]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi.queryUploadSshkey(params).then(
				(res) => {
					resolve(res.data)
				},
				(err) => {
					reject(err.data)
				},
			)
		})
	},
	// 获取阿里云ecs详情
	[STORE_CONST.CLUSTER.GET_ALIYUN_ECS]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.getEcsAliyunInfo(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},
	// 批量删除在线用户
	[STORE_CONST.CLUSTER.BAECH_DELETE_ONLINE_USER]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.batchDelOnlineUser(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},

	// 获取云账号的区域列表
	[STORE_CONST.CLUSTER.CLOUD_GET_REGIONS]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.getCloudRegions(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},
	// 云账号扫描ecs
	[STORE_CONST.CLUSTER.SCAN_INSTANCE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.scanInstance(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},
	// 导入扫描到的实例
	[STORE_CONST.CLUSTER.LOAD_INSTANCE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.loadInstance(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},
	// 获取资源列表
	[STORE_CONST.CLUSTER.GET_RESOURCE_LISTS]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.getResourceList(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},
	// 导出集群配置文件
	[STORE_CONST.CLUSTER.EXPORT_CLUSTER_CONFIG]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.exportClusterConfig(params)

				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},

	// 导入集群配置文件
	[STORE_CONST.CLUSTER.IMPORT_CLUSTER_CONFIG]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.importClusterConfig(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},

	// 轮询导入导出结果
	[STORE_CONST.CLUSTER.POLLING_CLUSTER_CONFIG]({ commit }, params) {
		return new Promise((resolve, reject) => {
			clusterApi
				.pollingClusterConfig(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err.data)
				})
		})
	},
}

const getters = {
	cluster: (state) => {
		return state.cluster
	},
}

export default {
	state,
	mutations,
	actions,
	getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/cluster.js